enum SortBy {
  None = 0,
  Asc = 1,
  Desc = 2,
}

export default SortBy;
